import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

import VueRouter from 'vue-router';
import Vuex from 'vuex';
import storeObj from './store.js';
import router from './router.js';
import VueCookies from 'vue-cookies'
import axios from 'axios'
import i18n from './locales';

import {initialRouteStr} from "./Constants";
import initFilters from '@/Filters'
import VueMasonry from 'vue-masonry-css'
import VueMarqueeSlider from 'vue-marquee-slider';

import Util from '@/modules/util';
import "@/assets/global.css"

Vue.prototype.$Util = Util;

console.log(process.env);

import GlobalRouter from './GlobalRouter.js';
import GlobalStore from './GlobalStore.js';
import CommonApiCall from './modules/CommonApiCall.js';
import ResponseCode from "./ResponseCode";


Vue.use(Vuex);
const store = new Vuex.Store(storeObj);

Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VueMasonry);
Vue.use(VueMarqueeSlider);


let apiPath = "";
let resourcePath = '';
if(process.env.NODE_ENV === 'production'){
  apiPath = "/";
  resourcePath = '';
}else if(process.env.NODE_ENV === 'development'){
  axios.defaults.baseURL = process.env.VUE_APP_TEST_URL + "/";
  apiPath = axios.defaults.baseURL;
  resourcePath = axios.defaults.baseURL;
  // resourcePath = 'http://obyungear-user.ubiplus.co.kr';
  // Vue.$cookies.set('device', 'android');
  // Vue.$cookies.set('device', 'ios');
  Vue.$cookies.set('device', 'pc');

}
Vue.prototype.$apiPath = apiPath;
Vue.prototype.$resourcePath = resourcePath;

GlobalRouter.init(router);
GlobalStore.init(store);
// router.setGlobalStore(GlobalStore);
Vue.prototype.$GlobalRouter = GlobalRouter;
Vue.prototype.$GlobalStore = GlobalStore;
Vue.prototype.$Axios = CommonApiCall;
Vue.prototype.$Once = (fn) => {
  let done = false;
  return async (...args) => {
    if (!done) {
      done = true;
      try{
        await fn(...args);
      }catch (e) {
          console.error(e)
      }
      done = false;
    }else {
      GlobalStore.showAlert('처리중입니다. 잠시만 기다려주세요.');
    }
  }
};


Vue.prototype.$hasOwnProperty = function(data, key){
    return Object.prototype.hasOwnProperty.call(data, key);
};

initFilters();

window.copyObject = function(obj){
  return JSON.parse(JSON.stringify(obj));
};

window.copyToClipboard = function(copyStr){
  var body = document.querySelector('body');
  var textArea = document.createElement("textarea");
  textArea.value = copyStr;
  body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  body.removeChild(textArea);
  store.commit('showToast', '복사되었습니다.');
};

window.goBack = function(){
    const modalLength = store.getters.modalLength
  if(modalLength === 0){
      if(store.state.pagePopFlags.length > 0){
          store.commit('closeLastPop', true);
          return;
      }

      var device = window.Vue.$cookies.get('device');
      if(device === 'android'){
        window.Android.closeApp();
      }
  } else {
      const lastModal = store.state.modals[modalLength - 1];
      // alert('실행' + JSON.stringify(store.state.modals.length));
      if(lastModal.popFlags && lastModal.popFlags.length > 0){
            store.commit('closeLastPop', true);
      }else {
          store.commit('closeLastModal');
      }

  }
};

window.detectKeyboardUp = () => {
    setTimeout(() => {
        document.activeElement.scrollIntoView({block : 'center', behavior : 'instant'});
    }, 0);
};

window.detectKeyboardDown = () => {};

axios.interceptors.request.use(function (config) {
  // store.commit('showProgress');
  config.metadata = { startTime: new Date()}
  return config;
}, function (error) {
  // store.commit('hideProgress');
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
    if(response.data.code === ResponseCode.VERSION_CHANGED && process.env.NODE_ENV === 'production'){
        GlobalStore.showSystemPatch();
        setTimeout(() => {
            location.href = initialRouteStr;
            GlobalStore.hideSystemPatch();
        }, 3000);
    }else if(response.data.code === ResponseCode.DELETE_MEMBER){
        location.href = '/';
    }

    response.config.metadata.endTime = new Date()
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime
    return response;
}, function (error) {
  GlobalStore.showToast('네트워크 오류가 발생했습니다.');
  // store.commit('hideProgress');
  return Promise.reject(error);
});

window.addEventListener('message', async function(e){
  var req = e.data;
  if(req.type === 'alreadyRegisted'){
    GlobalStore.closeLastModal(true);
    GlobalStore.closeLastModal(true);
    const res = await axios.get('/login/data');
    localStorage.removeItem('marketing_agree');
    GlobalStore.setLoginInfo(res.data.loginInfo);

      await Util.checkAfterLogin(res.data.isSoccerhowWritten);
    // GlobalRouter.push('/view/home');
  }else if(req.type === 'goRegist'){
    GlobalStore.closeLastModal();
    GlobalStore.addModal('KaKaoRegist', {id : req.id, mode : req.loginPlatform});
  }else if(req.type === 'phone_cert'){
      window.completePhoneCert(req.code, req.data);
  }
});

window.completeWebbrowser = function(url){
    const param = new URLSearchParams(url.split('?')[1]);
    const type = param.get('type');
    const data = param.get('data');
    const code = param.get('code');
    window.postMessage({type : type, code : code, data : data});
}

window.loginSocialIOS = function(url){
    const param = new URLSearchParams(url.split('?')[1]);
    const type = param.get('type');

    if(type === 'phone_cert'){
        const code = param.get('code');
        const data = param.get('data');
        window.postMessage({type : type, code : code, data : data});
    }else {
        const id = param.get('id');
        const loginPlatform = param.get('loginPlatform');
        window.postMessage({type : type, id : id, loginPlatform : loginPlatform});
    }
}

axios.defaults.headers.common = {
  // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  'X-Requested-With': 'XMLHttpRequest'
};

axios.defaults.withCredentials = true;

new Vue({
  store,
  i18n,
  router : router,
  render: h => h(App),
}).$mount('#app')
